<div class="container-fluid maap-root-container">
    <!-- <router-outlet></router-outlet> -->
    <app-header></app-header>
    <app-sidebar></app-sidebar>
    <div style="margin-top: 60px; margin-left: 80px; padding-top: 20px;">
        <header class="standalone-page-header px-3">
            <h1 class="standalone-page-title">Configuration Management</h1>
        </header>
        <p-toast position="top-center" life="10000"></p-toast>
        <!-- <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog> -->
        <div class="col-12 text-right" style="margin-bottom: 15px; display: flex; justify-content: flex-end; gap: 10px;">
            <p-button routerLink="/risk-scoring" *ngIf="showRiskScoring===true" [rounded]="true" severity="info">Risk Scoring</p-button>
            <p-button (click)="showConfigAdd()" [rounded]="true" severity="info">Add Config</p-button>
        </div>
        <div class="col-12">
            <p-table [value]="records" [lazy]="true" (onLazyLoad)="loadRecordsLazy($event)" [paginator]="true" [rows]="20" [totalRecords]="totalCount">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of cols">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="cols">
                    <tr>
                        <td *ngFor="let col of cols">

                            <ng-container *ngIf="col.header !== 'Actions';else actions">
                                {{rowData[col.field]}}
                            </ng-container>
                            <ng-template #actions>
                                <div style="display: flex; justify-content: center; gap: 8px;">
                                    <span pTooltip="Edit" tooltipPosition="bottom">
                                        <p-button icon="pi pi-user-edit" styleClass="p-button-rounded p-button-secondary p-button-text" (click)="showUpdateConfig(rowData)"></p-button>
                                    </span>
                                    <span pTooltip="Delete" tooltipPosition="bottom">
                                        <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-secondary p-button-text" (click)="deleteConfig(rowData)"></p-button>
                                    </span>
                                </div>
                            </ng-template>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-dialog header="Create Configuration" [(visible)]="configAddUpdate" [style]="{width: '30vw'}" class="popUpHeader">
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <label style="display:block;">Key</label>
                <input class="form-control" type="text" [(ngModel)]="scope.key" (change)="validateForm()" (keyup)="validateForm()" />
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label style="display:block;">Value</label>
                <textarea class="p-3" class="form-control rounded-0" [(ngModel)]="scope.value" rows="10" (change)="validateForm()" (keyup)="validateForm()"></textarea>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="form-group float-right mt-3">
            <p-button variant="text" severity="warn" (click)="this.configAddUpdate=false" type="button">Cancel</p-button>
            <p-button variant="text" severity="info" [disabled]="!isValid" (click)="submitConfig(); this.configAddUpdate=false" type="button">Submit</p-button>
        </div>
    </ng-template>
</p-dialog>
